import script from "./Contents.vue?vue&type=script&setup=true&lang=js"
export * from "./Contents.vue?vue&type=script&setup=true&lang=js"

import "./Contents.vue?vue&type=style&index=0&id=661f6484&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661f6484"]])

export default __exports__